var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.4375C8.76562 1.4375 11.0625 3.71094 11.0625 6.5C11.0625 9.3125 8.78906 11.5625 6 11.5625C3.1875 11.5625 0.9375 9.3125 0.9375 6.5C0.9375 3.71094 3.1875 1.4375 6 1.4375ZM6 0.6875C2.78906 0.6875 0.1875 3.3125 0.1875 6.5C0.1875 9.71094 2.78906 12.3125 6 12.3125C9.1875 12.3125 11.8125 9.71094 11.8125 6.5C11.8125 3.3125 9.1875 0.6875 6 0.6875ZM5.15625 8.75C4.99219 8.75 4.875 8.89062 4.875 9.03125V9.21875C4.875 9.38281 4.99219 9.5 5.15625 9.5H6.84375C6.98438 9.5 7.125 9.38281 7.125 9.21875V9.03125C7.125 8.89062 6.98438 8.75 6.84375 8.75H6.5625V5.46875C6.5625 5.32812 6.42188 5.1875 6.28125 5.1875H5.15625C4.99219 5.1875 4.875 5.32812 4.875 5.46875V5.65625C4.875 5.82031 4.99219 5.9375 5.15625 5.9375H5.4375V8.75H5.15625ZM6 3.125C5.57812 3.125 5.25 3.47656 5.25 3.875C5.25 4.29688 5.57812 4.625 6 4.625C6.39844 4.625 6.75 4.29688 6.75 3.875C6.75 3.47656 6.39844 3.125 6 3.125Z",
    fill: "#7FA9CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.60420400784a371508350c8b295579ea.svg";
export { ForwardRef as ReactComponent };